import React from 'react'
import SubmissionGroupsSection from './submission-groups/SubmissionGroupsSection'
import { Col, Row } from 'antd'
import SideSection from './side-section/SideSection'
import HeaderSection from './header-section/HeaderSection'
import useExpandQuestionsManager from './hooks/useExpandQuestionsManager'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import TextSubmissionDrawer from '../../components/text-submission-drawer/TextSubmissionDrawer'
import {
    useAutofocusOpenedQuestionRubric,
    useAutoOpenSubmissionFromParams,
    useResetRefinementStartedOnQuestionRubricChange,
} from '../../../../store/apis/utils/hooks/text-submission.hooks'
import submissionSelectors from '../../../../store/selectors/submission.selectors'
import useSubmissionGroups from './submission-groups/useSubmissionGroups'

const SubmissionsSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    const someSubmissionIsOpened = useSelector(submissionSelectors.someIsOpened)
    const { groups } = useSubmissionGroups()

    useDocumentTitle(`${assignmentName || ''} Submissions`)
    useExpandQuestionsManager()
    useAutofocusOpenedQuestionRubric()
    useAutoOpenSubmissionFromParams(groups)
    useResetRefinementStartedOnQuestionRubricChange()

    return (
        <Row gutter={16}>
            <TextSubmissionDrawer />
            {!someSubmissionIsOpened && (
                <>
                    <Col span={5}>
                        <SideSection />
                    </Col>
                    <Col span={19}>
                        <HeaderSection />
                        <SubmissionGroupsSection />
                    </Col>
                </>
            )}
        </Row>
    )
}

export default SubmissionsSection
